export default {
  'aiVectors.form.openAIVectorStoreId': 'OpenAI Vector Store ID',
  'aiVectors.form.isManaged': 'Managed',

  'aiVectors.files.title': 'Training documents',
  'aiVectors.files.add': 'Add documents',
  'aiVectors.files.count': '{count, plural, one {# document} other {# documents}}',
  'aiVectors.files.empty': 'No documents added to this vector yet.',
  'aiVectors.files.loading': 'Loading documents…',
  'aiVectors.files.uploading': 'Uploading…',
  'aiVectors.files.uploadError': 'The file could not be processed.',
  'aiVectors.files.tooLarge': 'The file exceeds the {max} MB limit.',
  'aiVectors.files.dragText': 'Drag files here or click to upload',
  'aiVectors.files.dragHint':
    'PDF, Word, Excel, CSV, TXT, MD, JSON or images · up to {max} MB each',
  'aiVectors.files.synced': 'Synced',
  'aiVectors.files.pendingSync': 'Syncing',
  'aiVectors.files.syncFailed': 'Sync failed',
  'aiVectors.files.lastSyncAttempt': 'Last attempt',
  'aiVectors.files.retrySync': 'Retry sync',
  'aiVectors.files.retryAll': 'Retry sync',
  'aiVectors.files.retryAllHint':
    '{count, plural, one {# document pending sync} other {# documents pending sync}}',
  'aiVectors.files.readonlyHint': 'Edit the vector to add or remove documents.',
};
